(function ($) {
  $(document).ready(function () {

    $('#Quantity').on('change', function () {
      this.value == 0 ? $('#AddToCart-product-template-1').addClass('phone-disable disabled') : $('#AddToCart-product-template-1').removeClass('phone-disable disabled')
    });

    //dropdown for cart qty
    if($('.cart_quantity_select').length > 0) {
          $('.cart_quantity_select').select2();
    }
  
      $('.product-form__quantity').on("select2:select", function (e) {
    var data = e.params.data;
    let quantity = $(this).val();
        console.log(quantity)
    let line = $(this).data('line');
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: $.proxy(function (cart) {
        let qty = new QtySelector($(this))
        qty.updateCartItemCallback(cart);
      }, this)
    };
        $.ajax(params).then(()=>{window.location.reload(true)}).catch(err=> console.log(err))
  });

    // next-arrow
    var owl = $(".bs-slider");
    if (owl.length > 0) {
      owl.owlCarousel({
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        items: 3,
        loop: true,
        center: false,
        rewind: false,
        margin: 35,
        merge: false,
        mergeFit: true,
        autoWidth: false,
        startPosition: 0,
        rtl: false,
        smartSpeed: 200,
        fluidSpeed: false,
        dragEndSpeed: false,
        dots: false,
        slideBy: 1,
        nav: true,
        slideBy: 1,
        navText: [
          "<div onclick='javascript:void(0)' class='arrow prev-slide'><i class='fa-solid fa-arrow-left'></i></div>",
          "<div onclick='javascript:void(0)' class='arrow next-slide'><i class='fa-solid fa-arrow-right'></i></div>"
        ],
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          1200: {
            items: 2
          },
          1365: {
            items: 3
          }
        },
        lazyLoad: false
      });

      $(".next-slide").click(function () {
        owl.trigger("next.owl.carousel");
      });
      $(".prev-slide").click(function () {
        owl.trigger("prev.owl.carousel");
      });
    }

    if ($("#Quantity").length > 0) {
      $("#Quantity").select2();
    }
    
    if ($(".collection-sortby .filter").length > 0) {
      $(".collection-sortby .filter").on('click, hover', function () {
        if ($(".collection-sortby .filter").hasClass('collapse-dropdown')) {
          $(".collection-sortby .filter").removeClass('collapse-dropdown');
        } else {
          $(".collection-sortby .filter").addClass('collapse-dropdown');
        }
      });
    }

    $(window).on('load', function () {
      let cart_qty = $('#Quantity').val()
      cart_qty == 0 ? $('#AddToCart-product-template-1').addClass('phone-disable disabled') : $('#AddToCart-product-template-1').removeClass('phone-disable disabled')
      setTimeout(() => {
        $('.g-variant-color-detail li').each(function (e) {
          var myColorData = $(this).attr("data-value");
          $(this).addClass(myColorData.toLowerCase());
        });
      }, 4000)
    });

   if ($("#ul_list_categories").children('li').hasClass('active')){
     $('.remove-filter-text').css('display', 'block')
    $("#ul_list_categories").children('li').each(function() {
      if($(this).hasClass('active')){
        $(this).children('.js-filter-isotope').addClass('active');
        return true
        }
      $(this).children('.js-filter-isotope').addClass('phone-disable');
 	  $(this).find('.check__box').css("background-color", '#D5D5D5');
     });
     }
    $('body').on('click',function (e){
      const container = $('.js-mini-cart');
      if(!container.is(e.target) && container.has(e.target).length === 0){
        container.removeClass('active')
      }
    })

    // clear filter toggle
    $('.js-filter-isotope').on('click', function () {
      if($(this).hasClass('active') && $("#ul_list_categories").children('li').children('.active').length <= 1 ){
        $('.remove-filter-text').css('display', 'none')
      }else{
        $('.remove-filter-text').css('display', 'block')
      }
    })

    // cleart cart qty
    $('#clear-qty').on('click', function(){
      $('#Quantity').val(0).trigger('change')
    })
  });
})(jQuery); 
